var map = {
	"./desserts/biscuit.svg": 817,
	"./desserts/compote.svg": 818,
	"./desserts/fromage.svg": 819,
	"./desserts/fruits-secs.svg": 820,
	"./desserts/gateau.svg": 821,
	"./desserts/glace.svg": 822,
	"./desserts/jus.svg": 823,
	"./desserts/salade-fruits.svg": 824,
	"./desserts/tarte.svg": 825,
	"./desserts/yaourt.svg": 826,
	"./feculents/ble.svg": 827,
	"./feculents/pain.svg": 828,
	"./feculents/pates.svg": 829,
	"./feculents/pomme-de-terre.svg": 830,
	"./feculents/riz.svg": 831,
	"./feculents/semoule.svg": 832,
	"./fruits/abricot.svg": 833,
	"./fruits/ananas.svg": 834,
	"./fruits/banane.svg": 835,
	"./fruits/cerises.svg": 836,
	"./fruits/clementines.svg": 837,
	"./fruits/fraises.svg": 838,
	"./fruits/kiwi.svg": 839,
	"./fruits/mangue.svg": 840,
	"./fruits/melon.svg": 841,
	"./fruits/nectarine.svg": 842,
	"./fruits/orange.svg": 843,
	"./fruits/pamplemousse.svg": 844,
	"./fruits/pasteque.svg": 845,
	"./fruits/peche.svg": 846,
	"./fruits/poire.svg": 847,
	"./fruits/pomme.svg": 848,
	"./fruits/prune.svg": 849,
	"./fruits/raisin.svg": 850,
	"./legumes/Artichauts.svg": 851,
	"./legumes/Choux-de-bruxelles.svg": 852,
	"./legumes/asperges.svg": 853,
	"./legumes/aubergines.svg": 854,
	"./legumes/betteraves.svg": 855,
	"./legumes/brocolis.svg": 856,
	"./legumes/carottes.svg": 857,
	"./legumes/celeris.svg": 858,
	"./legumes/champignons.svg": 859,
	"./legumes/choux-fleur.svg": 860,
	"./legumes/choux.svg": 861,
	"./legumes/concombres.svg": 862,
	"./legumes/courge.svg": 863,
	"./legumes/courgette.svg": 864,
	"./legumes/cresson.svg": 865,
	"./legumes/epinards.svg": 866,
	"./legumes/fenouils.svg": 867,
	"./legumes/haricots.svg": 868,
	"./legumes/laitues.svg": 869,
	"./legumes/mais.svg": 870,
	"./legumes/navets.svg": 871,
	"./legumes/petits-pois.svg": 872,
	"./legumes/poireaux.svg": 873,
	"./legumes/poivrons.svg": 874,
	"./legumes/potage.svg": 875,
	"./legumes/radis.svg": 876,
	"./legumes/salade.svg": 877,
	"./legumes/tomates.svg": 878,
	"./proteines/agneau.svg": 879,
	"./proteines/lait-de-soja.svg": 880,
	"./proteines/oeuf-au-plat.svg": 881,
	"./proteines/oeuf-brouilles.svg": 882,
	"./proteines/oeufs.svg": 883,
	"./proteines/omelette.svg": 884,
	"./proteines/poisson.svg": 885,
	"./proteines/porc.svg": 886,
	"./proteines/viande.svg": 887,
	"./proteines/volaille.svg": 888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;